// copied from https://material-ui.com/components/menus/


import React from 'react'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'inline-block',
    },
    paper: {
        // marginRight: theme.spacing(2),
    },
}))

export default function MenuListComposition(props) {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false)
    const anchorRef = React.useRef(null)

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    return (
        <div className={classes.root}>
            <div>
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    <div style={{ color: 'blue', textDecoration: 'underline' }}>{props.menuTitle}</div>
                </Button>
                <Popper open={open}
                    anchorEl={anchorRef.current}
                    // transformOrigin={{
                    //   vertical: 'top',
                    //   horizontal: 'left',
                    // }}
                    // anchorOrigin={{
                    //   vertical: 'bottom',
                    //   horizontal: 'left',
                    // }}
                    placement={'bottom-start'}
                    role={undefined}
                    transition
                    style={{ zIndex: 2 }}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                        {props.listItems.map((ele) => {
                                            return (
                                                <MenuItem
                                                    onClick={(e) => { ele.onClick(); handleClose(e) }}>
                                                    {ele.text}
                                                </MenuItem>
                                            )
                                        })}
                                        {/* <MenuItem>a</MenuItem> */}
                                        {/* <MenuItem>b</MenuItem> */}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </div>
    )
}